<div class="cs-indicators">
    <div class="cs-single-indicators-data" >
        <cs-single-indicator [dataSource]="data"
                             [dataAnnotation]="data.dataAnnotation">
        </cs-single-indicator>
      </div>
</div>
